module.exports = __webpack_public_path__ + "img/ES-M-3.17c9f571.svg";